export default __webpack_public_path__ + "static/ScalingWeb-65715471d6a88180d01929337a0e87e5.png";